import React from 'react'

export const Footer = () => {
    return (
        <footer className="bg-dark text-light py-5">
            <h4>Designed and Developed by &copy; Khushhal</h4>
        </footer>
    )
}
